import React, { createContext, useContext } from 'react';
import { SignedInUser } from './types';

const Session = createContext<SignedInUser | null>(null);

export function SessionProvider(
  { user, children }: { user: SignedInUser; children: React.ReactNode }
) {
  return <Session.Provider value={user}>{children}</Session.Provider>;
}

/**
 * Ko je prijavljen.
 *
 * Postoji da ime uz odluku ne bi putovalo kroz pet komponenti kao prop, ni da
 * ga svaka traži svojim poljem — ranije je svaki ekran imao svoje „Odlučuje" i
 * svoju kopiju u localStorage, pa je isti čovek umeo da bude tri različita
 * potpisa.
 *
 * Server ionako uzima ime iz prijave; ovo je samo da ekran pokaže isto.
 */
export function useSignedIn(): SignedInUser {
  const user = useContext(Session);

  if (!user) {
    // Ne može se desiti: bez prijavljenog korisnika ekrani se ne prikazuju.
    throw new Error('Nema prijavljenog korisnika.');
  }

  return user;
}
